import { render, staticRenderFns } from "./LayoutContentRendererFolder.vue?vue&type=template&id=56885e82&scoped=true&"
import script from "./LayoutContentRendererFolder.vue?vue&type=script&lang=js&"
export * from "./LayoutContentRendererFolder.vue?vue&type=script&lang=js&"
import style0 from "./LayoutContentRendererFolder.vue?vue&type=style&index=0&id=56885e82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56885e82",
  null
  
)

export default component.exports